<div class="enabler-card" [style.border-top-color]="color()" (click)="goToEkpis()">
    @if (logo(); as source) {
        <img class="enabler-card__icon" [src]="source" [attr.alt]="data() | translateToken: 'name'" />
    } @else {
        <span class="enabler-card__icon enabler-card__initials">{{ initials() }}</span>
    }

    <div class="enabler-card__body">
        <span class="enabler-card__value" [style.color]="color()">
            @if (progress() > 0) {
                <adaa-count-up [total]="data().performance" />
            } @else {
                {{ data().performance | percentageValue }}
            }
        </span>

        <span class="enabler-card__label">{{ data() | translateToken: "name" }}</span>
    </div>

    <span
        class="enabler-card__bar"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-valuenow]="progress()"
        [attr.aria-label]="'ekpi.performance' | translate"
    >
        <span [style.width.%]="progress()" [style.background-color]="color()"></span>
    </span>

    <div class="enabler-card__actions d-flex justify-content-between align-items-center">
        <div class="enabler-card__action-group d-flex">
            <button class="enabler-card__btn" [title]="'common.form.label.performance_comparison' | translate" (click)="clickGraphIcon($event)">
                <fa-icon [icon]="graphIcon" />
            </button>
        </div>
    </div>
</div>
